import { ActionCreator, ReducerTypes, createReducer, on } from '@ngrx/store';

import * as actions from './service-request-completed.actions';
import { ServiceRequestCompletedState } from './service-request-completed.state';

export const serviceRequestCompletedInitialState: ServiceRequestCompletedState = {
  nextAction: '',
  warningMessageList: [
    {
      messageId: '',
      apiErrorCode: '',
      interpolateParams: [],
    },
  ],
  paymentInfo: {
    purchaseResults: '',
    is3DSecureApplied: false,
    paymentMethod: '',
  },
};

export const serviceRequestCompletedReducerFeatures: ReducerTypes<ServiceRequestCompletedState, ActionCreator[]>[] = [
  on(actions.setStateServiceRequestCompleted, (_state, payload) => ({ ...payload })),
  on(actions.updateStateServiceRequestCompleted, (state, payload) => ({ ...state, ...payload })),
  on(actions.resetStateServiceRequestCompleted, () => serviceRequestCompletedInitialState),
];

export const serviceRequestCompletedReducer = createReducer(
  serviceRequestCompletedInitialState,
  ...serviceRequestCompletedReducerFeatures
);
